import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { HeaderComponent } from "./header/header.component";

@Component({
    standalone: true,
    selector: "gwo-layout",
    imports: [HeaderComponent],
    templateUrl: "./layout.component.html",
    styleUrl: "./layout.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent {
    @Input() name = "";
}
